import React from 'react'
import Link from 'gatsby-link'
import ReactSlick from 'react-slick'
import styled from 'styled-components'
import { above, below, maxHeight } from '../style/functions'
import * as vars from '../style/vars'

// import 'slick-carousel/slick/slick.css'
// import 'slick-carousel/slick/slick-theme.css'

import Video from '../components/video'
import Header from '../components/header.js'
import TextBlock from '../components/content_block'
import InstagramFeed from '../components/instagram-feed'

import { RichText, Date } from 'prismic-reactjs'

import NextArrowImg from '../../static/svg/arrow-right-white.svg'
import PrevArrowImg from '../../static/svg/arrow-right-white.svg'
import StickyEnquire from '../components/sticky-enquire'

import { NextArrow, PrevArrow } from '../components/arrows'

let settings = {
	dots: true,
	dotsClass: 'slick-dots grid',
	//   autoplay: true,
	fade: true,
	infinite: true,
	autoplaySpeed: 4750,
	pauseOnHover: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	waitForAnimate: false,
	nextArrow: <NextArrow />,
	prevArrow: <PrevArrow />,
}

class homePage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			autoplay: true,
		}
		this.pause = this.pause.bind(this)
	}

	pause() {
		this.setState({ autoplay: false })
	}

	componentDidMount() {
		const meta = this.props.data.prismicHomepagev2.data
		this.props.updateMeta(meta.meta_title.text, meta.meta_description)
		this.props.togglePopup(false)
		this.props.updatePageType(this.props.data.prismicHomepagev2.type)
		this.props.updateFooterVisible(true)
		if (document) {
			if ( document.querySelector('.prev-arrow') !== null ) {
				document.querySelector('.prev-arrow').addEventListener('click', this.pause)
			}

			if ( document.querySelector('.next-arrow') !== null ) {
				document.querySelector('.next-arrow').addEventListener('click', this.pause)
			}

			if ( document.querySelector('.slick-dots') !== null ) {
				document.querySelector('.slick-dots').addEventListener('click', this.pause)
			}

			if ( document.querySelector('.video-wrapper>div') !== null ) {
				document.querySelector('.video-wrapper>div').addEventListener('click', this.pause())
			}
		}
	}

	componentWillMount = () => {}

	render() {
		let data = this.props.data.prismicHomepagev2.dataString
		data = JSON.parse(data)

		let data2 = this.props.data.prismicMainNavigation.dataString
		data2 = JSON.parse(data2)

		const {
			body: [
				{ items: slides },
				{ primary: textGrey },
				{ primary: youTube },
				{ primary: textWhite },
				{ items: tileGrid },
			],
		} = this.props.data.prismicHomepagev2.data

		const allSlides = []
		slides.map((slide, i) => {
			const link = slide.link.text
			const link_text = slide.link_text.text
			const slide_bg_image = slide.slide_bg_image.url
			const slide_bg_mobile_image = typeof slide.slide_bg_mobile_image !== 'undefined' ? slide.slide_bg_mobile_image.url : false;
			const slide_description = slide.slide_description.html
			const slide_title = slide.slide_title.text

			const link_is_external = /^(http[s]?|\/\/)/.test(slide.link.text);

			allSlides.push({
				id: i,
				slide_title,
				slide_description,
				slide_bg_image,
				slide_bg_mobile_image,
				link_text,
				link,
				link_is_external,
			})

			return allSlides
		})

		const allGrid = []
		tileGrid.map((gridItem, i) => {
			const link = gridItem.link.text
			const link_text = gridItem.link_text.text
			const bg = gridItem.tile_background.url
			const description = gridItem.description.html
			const title = gridItem.title.html
			const youtube_link = gridItem.youtube__optional_
				? gridItem.youtube__optional_.url
				: false

			allGrid.push({ id: i, title, description, bg, link_text, link, youtube_link })

			return allGrid
		})

		return (
			<div>
				<Header
					togglePopup={this.props.togglePopup}
					theme='trans'
					menu={this.props.data.prismicMainNavigation.data}
				/>
				<StickyEnquire
					theme='light'
					togglePopupState={this.props.popupVisible}
					togglePopup={this.props.togglePopup}
					utm={this.props.utm}
					updateFormDetails={(first_name, last_name, phone, email) =>
						this.props.updateFormDetails(first_name, last_name, phone, email)
					}
				/>

				<SlideshowWrapper>
					<ReactSlick autoplay={this.state.autoplay} {...settings}>
						{allSlides.map((slide, i) => (
							<SlideImgWrapper key={i}>
								<div className='img'>
									<picture>
										{slide.slide_bg_mobile_image && (<source
											media='(max-width: 600px)'
											srcSet={slide.slide_bg_mobile_image}
										/>)}
										<img src={slide.slide_bg_image} />
									</picture>
								</div>

								<Blurb className='blurb'>
									<div className='grid'>
										<div className='inner'>
											<h1>
												{slide.slide_title
													.split('\n')
													.map(function(item, key) {
														return (
															<span key={key}>
																{item}
																<br />
															</span>
														)
													})}
											</h1>
											<div
												dangerouslySetInnerHTML={{
													__html: slide.slide_description,
												}}
											/>

											{ ! slide.link_is_external ? (
												<Link to={slide.link} className='btn btn-square white'>
													<span>{slide.link_text}</span>
												</Link>
											) : (
												<a href={slide.link} className='btn btn-square white' target='_blank'>
													<span>{slide.link_text}</span>
												</a>
											)}
										</div>
									</div>
								</Blurb>
							</SlideImgWrapper>
						))}
					</ReactSlick>
				</SlideshowWrapper>

				<VideoContent>
					<TextBlock
						header={[{ type: 'heading1', text: textGrey.title.text, spans: [] }]}
						subheader={[{ type: 'heading2', text: '', spans: [] }]}
						text={[{ type: 'paragraph', text: textGrey.text.text, spans: [] }]}
						cta={textGrey.link.text}
						ctaText={textGrey.link_text.text}
						invertColor={true}
						home={true}
					/>

					<div className='grid'>
						<div className='inner'>
							<div className='col col-xs-12 col-12 '>
								{/*   <Video poster="/images/feb-19-updates/home/Lensaloft_D815184@2x-min.jpg" url="https://www.youtube.com/watch?v=_bh_F0-ii_I" inline />*/}
								<Video poster={youTube.poster.url} url={youTube.link.text} inline />
							</div>
						</div>
					</div>

					<TextBlock
						header={[{ type: 'heading1', text: textWhite.title.text, spans: [] }]}
						subheader={[{ type: 'heading2', text: '', spans: [] }]}
						text={[{ type: 'paragraph', text: textWhite.text.text, spans: [] }]}
						cta={textWhite.link.text}
						ctaText={textWhite.link_text.text}
						invertColor={false}
					/>
				</VideoContent>

				<FeatureWrapper>
					<div className='grid'>
						<div className='inner'>
							{allGrid[0].youtube_link ? (
								<FeatureVideos className='h100'>
									<div className='text'>
										<div
											dangerouslySetInnerHTML={{
												__html: allGrid[0].title,
											}}
										></div>
										<div
											dangerouslySetInnerHTML={{
												__html: allGrid[0].description,
											}}
										></div>
										<span
											style={{cursor: 'pointer', 'pointer-events': 'none'}}
											className='btn btn-square transparent'
										>
											<span>{allGrid[0].link_text}</span>
										</span>
									</div>
									<Video
										url={allGrid[0].youtube_link}
										poster={allGrid[0].bg}
										popup
									/>
								</FeatureVideos>
							) : (
								<FeatureItems
									className='h100'
									style={{ backgroundImage: `url(${allGrid[0].bg})` }}
								>
									<div dangerouslySetInnerHTML={{ __html: allGrid[0].title }} />
									<div
										dangerouslySetInnerHTML={{ __html: allGrid[0].description }}
									/>

									<Link
										to={allGrid[0].link}
										className='btn btn-square transparent'
									>
										<span>{allGrid[0].link_text}</span>
									</Link>
								</FeatureItems>
							)}

							<Flex>
								{allGrid[1].youtube_link ? (
									<FeatureVideos className='h100'>
										<div className='text'>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[1].title,
												}}
											></div>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[1].description,
												}}
											></div>
											<span
												style={{cursor: 'pointer', 'pointer-events': 'none'}}
												className='btn btn-square transparent'
											>
												<span>{allGrid[1].link_text}</span>
											</span>
										</div>
										<Video
											url={allGrid[1].youtube_link}
											poster={allGrid[1].bg}
											popup
										/>
									</FeatureVideos>
								) : (
									<FeatureItems
										className='h100 '
										style={{ backgroundImage: `url(${allGrid[1].bg})` }}
									>
										<div className='text'>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[1].title,
												}}
											/>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[1].description,
												}}
											/>
											<Link
												to={allGrid[1].link}
												className='btn btn-square transparent'
											>
												<span>{allGrid[1].link_text}</span>
											</Link>
										</div>
									</FeatureItems>
								)}

								<Flex className='dir-column'>
									{allGrid[2].youtube_link ? (
										<FeatureVideos className='h100'>
											<div className='text'>
												<div
													dangerouslySetInnerHTML={{
														__html: allGrid[2].title,
													}}
												></div>
												<div
													dangerouslySetInnerHTML={{
														__html: allGrid[2].description,
													}}
												></div>
												<span
													style={{cursor: 'pointer', 'pointer-events': 'none'}}
													className='btn btn-square transparent'
												>
													<span>{allGrid[2].link_text}</span>
												</span>
											</div>
											<Video
												url={allGrid[2].youtube_link}
												poster={allGrid[2].bg}
												popup
											/>
										</FeatureVideos>
									) : (
										<FeatureItems
											className=''
											style={{ backgroundImage: `url(${allGrid[2].bg})` }}
										>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[2].title,
												}}
											/>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[2].description,
												}}
											/>
											<Link
												to={allGrid[2].link}
												className='btn btn-square transparent'
											>
												<span>{allGrid[2].link_text}</span>
											</Link>
										</FeatureItems>
									)}

									{allGrid[3].youtube_link ? (
										<FeatureVideos className='h100'>
											<div className='text'>
												<div
													dangerouslySetInnerHTML={{
														__html: allGrid[3].title,
													}}
												></div>
												<div
													dangerouslySetInnerHTML={{
														__html: allGrid[3].description,
													}}
												></div>
												<span
													style={{cursor: 'pointer', 'pointer-events': 'none'}}
													className='btn btn-square transparent'
												>
													<span>{allGrid[3].link_text}</span>
												</span>
											</div>
											<Video
												url={allGrid[3].youtube_link}
												poster={allGrid[3].bg}
												popup
											/>
										</FeatureVideos>
									) : (
										<FeatureItems
											className=''
											style={{ backgroundImage: `url(${allGrid[3].bg})` }}
										>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[3].title,
												}}
											/>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[3].description,
												}}
											/>
											<Link
												to={allGrid[3].link}
												className='btn btn-square transparent'
											>
												<span>{allGrid[3].link_text}</span>
											</Link>
										</FeatureItems>
									)}
								</Flex>
							</Flex>

							<Flex>
								{allGrid[4].youtube_link ? (
									<FeatureVideos className='h100'>
										<div className='text'>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[4].title,
												}}
											></div>
											<div
												dangerouslySetInnerHTML={{
													__html: allGrid[4].description,
												}}
											></div>
											<span
												style={{cursor: 'pointer', 'pointer-events': 'none'}}
												className='btn btn-square transparent'
											>
												<span>{allGrid[4].link_text}</span>
											</span>
										</div>
										<Video
											url={allGrid[4].youtube_link}
											poster={allGrid[4].bg}
											popup
										/>
									</FeatureVideos>
								) : (
									<FeatureItems
										className=''
										style={{ backgroundImage: `url(${allGrid[4].bg})` }}
									>
										<div
											dangerouslySetInnerHTML={{ __html: allGrid[4].title }}
										/>
										<div
											dangerouslySetInnerHTML={{
												__html: allGrid[4].description,
											}}
										/>
										<Link
											to={allGrid[4].link}
											className='btn btn-square transparent'
										>
											<span>{allGrid[4].link_text}</span>
										</Link>
									</FeatureItems>
								)}
							</Flex>
						</div>
					</div>
				</FeatureWrapper>

				{/* <div className="grid">
               <div className="inner">
                  <div className="col col-xs-12 col-12 ">
                     <SocialTitle><a href="https://www.instagram.com/yarrabend_/" target="_blank" >@yarrabend_</a></SocialTitle>
                     <InstagramFeed />
                  </div>
               </div>
            </div> */}
			</div>
		)
	}
}

const SlideshowWrapper = styled.div`
	.slick-track {
		background-color: #3f3e3e;
	}

	.slick-track,
	.slick-list {
		transform: none !important;
	}

	.arrow {
		position: absolute;
		display: block;
		height: 50px;
		width: 50px;
		z-index: 1;
		top: 60%;
		transform: translateY(-50%);
		margin: 0 2vw;
		cursor: pointer;
		z-index: 4;
		${below.mid`
         display: none;
      `}
	}

	.next-arrow {
		right: 0;
		background-image: url(${NextArrowImg});
	}
	.prev-arrow {
		transform: rotate(180deg);
		transform-origin: 50% 24%;
		background-image: url(${PrevArrowImg});
	}

	.slick-dots {
		bottom: 9%;
		width: 100%;
		list-style: none;
		text-align: center;
		z-index: 4;
		padding-left: 3.5rem;
		padding-right: 3.5rem;
		margin: auto;
		left: 0;
		right: 0;
		text-align: left;
		position: absolute;
		${below.mobile`
				text-align: right;
				width: 40%;
				right: 0;
				left: initial !important;
				transform: none !important;
			`}
		li {
			${below.mobile`
					margin-right: 0;
				`}
			&:first-of-type {
				${above.giant`
					margin-left: 13.25rem;
					`};
			}
			button {
				background: transparent;
				border: 1px solid white;
				border-radius: 50%;
				width: 20px;
				height: 20px;
				${below.mobile`
				 width:12px;
				 height:12px;
				 `}
				&:before, &:after {
					width: 20px;
					height: 20px;
					${below.mobile`
				 width:12px;
				 height:12px;
				 `}
				}
				:hover:before {
					background: white;
					opacity: 1;
				}
				:before {
					content: '';
					background-color: white;
					border-radius: 50%;
					opacity: 0;
					transition: opacity 0.5s;
				}
			}
			&.slick-active button:before {
				background: white;
				opacity: 1;
			}
		}

		${below.tablet`
         margin: 0;
         left: 50%;
         bottom: 3%;
         transform: translateX(-50%);
      `}
	}
`
const SlideImgWrapper = styled.div`
	height: 100vh;
	${below.mobile`
	height: 90vh;
   `}

	img {
		width: 100%;
		height: 100vh;
		object-fit: cover;

		${below.mobile`
	      height: 90vh;
	   `}
	}
	.img {
		position: relative;
		&:before {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background: linear-gradient(
				to bottom,
				rgba(63, 62, 62, 0.4) 0%,
				rgba(63, 62, 62, 0.2) 20%,
				rgba(0, 0, 0, 0) 100%
			);
		}
	}
`
const Blurb = styled.div`
	/* border: 1px solid magenta; */
	width: 100%;
	position: absolute;
	color: white;
	top: 30%;
	z-index: 4;
	left: 0;
	margin-top: 110px;
	pointer-events: none;

	${maxHeight.tablet`
	   margin-top:-30px;
	`}
	${below.mobile`
	   margin-top: 0;
		top: initial;
		bottom: 3%;
   `}

   p {
		background: rgba(0, 0, 0, 0.6);
		box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.6);
		padding: 0;
		margin-bottom: 15px;
		max-width: 500px;
		${below.mobile`
      background: rgba(0, 0, 0, 0.4);
      box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.4);
      `}
	}

	h1 {
		font-size: 7.7rem;
		line-height: 7.7rem;
		padding-bottom: 15px;
		${below.mobile`
         font-size: 4.5rem;
         line-height: 0.9;
         letter-spacing: 0;
      `}
	}
	${below.tablet`
      margin-left: 2rem;
      width: 90%;
   `}

	a {
		pointer-events: auto;
	}
`

const VideoContent = styled.div`
	border-top: 1px solid;
	border-bottom: none;
	background-image: linear-gradient(${vars.colors.body} 60%, white 30%);

	.grid {
		margin: 7rem auto;
	}
`

const FeatureWrapper = styled.div`
   position: relative;
   display: block;
   z-index: 10;
   padding-top: 10rem;
   padding-bottom: 10rem;

   ${below.tablet`
      padding: 3rem 0;
      background-color: ${vars.colors.body}
   `}
`

const FeatureItems = styled.div`
	position: relative;
	overflow: hidden;
	color: ${vars.colors.blank};
	padding: 24.1rem 5rem 3rem 5rem;
	background-size: cover;
	background-position: center bottom;
	flex-basis: 97%;

	&:first-child:last-child {
		flex-basis: 100%;
	}

	h3 {
		max-width: 28rem;
		padding-bottom: 1rem;
	}

	h3,
	p {
		position: relative;
	}

	&.h100 {
		position: relative;
		padding-top: 55rem;

		${below.tablet`
         padding-top: 24.1rem;
      `};

		.text {
			${above.desktop`
         position: absolute;
         bottom:5rem;
         `};
		}
	}

	${below.tablet`
      padding: 24.1rem 2rem 2rem 2rem;
   `}

	&:before {
		content: '';
		width: 101%;
		height: 101%;
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		background-image: linear-gradient(
			0,
			rgba(0, 0, 0, 0.8) 0%,
			rgba(0, 0, 0, 0.3) 40%,
			rgba(241, 111, 92, 0) 100%
		);
	}
`

const FeatureVideos = styled.div`
	position: relative;
	overflow: hidden;
	color: ${vars.colors.blank};
	padding: 24.1rem 0 3rem 5rem;
	background-size: cover;
	background-position: center bottom;
	flex-basis: 97%;

	${below.desktop`
	   padding: 24.1rem 5rem 3rem 5rem;
   `}

	h3 {
		max-width: 28rem;
		padding-bottom: 1rem;
	}

	h3,
	p {
		position: relative;
		z-index: 4;
	}

	&.h100 {
		position: relative;
		padding-top: 55rem;

		${below.tablet`
         padding-top: 24.1rem;
      `};

		.text {
			${above.desktop`
         position: absolute;
         bottom:5rem;
         `};
		}
	}

	${below.tablet`
      padding: 24.1rem 0 2rem 2rem;
   `}

	&:before {
		content: '';
		width: 101%;
		height: 101%;
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		background-image: linear-gradient(
			0,
			rgba(0, 0, 0, 0.8) 0%,
			rgba(0, 0, 0, 0.3) 40%,
			rgba(241, 111, 92, 0) 100%
		);
	}

	.video-wrapper {
		position: absolute;
		top: 0;
		left: 0;
	}

	.btn {
		z-index: 4;
	}
`

const Flex = styled.div`
	display: flex;
	flex-direction: row;

	&.dir-column {
		width: 100%;
		margin: 0 auto;
		flex-direction: column;
		flex-grow: 1;
	}

	${below.tablet`
      flex-direction: column;
   `};
`

const SocialTitle = styled.h2`
	padding-top: 40px;
	a {
		text-decoration: none;
	}
`

export const pageQuery = graphql`
	query home($id: String) {
		prismicHomepagev2(id: { eq: $id }) {
			id
			type
			dataString
			data {
				meta_title {
					html
					text
				}
				meta_description
				body {
					... on PrismicHomepagev2BodySlider {
						slice_type
						items {
							#slide_bg_mobile_image {
							#	url
							#}
							slide_bg_image {
								url
							}
							slide_title {
								text
							}
							slide_description {
								html
							}
							link_text {
								text
							}
							link {
								text
							}
						}
					}
					... on PrismicHomepagev2BodyTextBlockGrey {
						slice_type
						primary {
							title {
								text
							}
							text {
								text
							}
							link_text {
								text
							}
							link {
								text
							}
						}
					}

					... on PrismicHomepagev2BodyYoutube {
						slice_type
						primary {
							poster {
								url
							}
							link {
								text
							}
						}
					}

					... on PrismicHomepagev2BodyTextBlockWhite {
						slice_type
						primary {
							title {
								text
							}
							text {
								text
							}
							link_text {
								text
							}
							link {
								text
							}
						}
					}

					... on PrismicHomepagev2BodyTileGrid {
						slice_type
						items {
							tile_background {
								url
							}
							title {
								html
								text
							}
							description {
								html
								text
							}
							link_text {
								html
								text
							}
							link {
								html
								text
							}
							youtube__optional_ {
								url
							}
						}
					}
				}
			}
		}
		prismicMainNavigation {
			id
			dataString
			data {
				display_name {
					html
					text
				}
				nav {
					slice_type
					primary {
						label {
							text
						}
						link {
							text
						}
					}
					items {
						sub_nav_link_label {
							text
						}
						sub_nav_link {
							text
						}
					}
				}
			}
		}
	}
`

export default homePage



// WEBPACK FOOTER //
// ./src/pages/index.js